import React, { FC } from "react";

import { StyledButton } from "./PopoverButton.styled";

import { Stack, Typography } from "@components/base";

export interface PopoverButton {
  title: string;
  description: string;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
}

const PopoverButton: FC<PopoverButton> = ({
  title,
  description,
  disabled = false,
  loading = false,
  onClick,
}) => (
  <StyledButton
    onClick={!disabled && !loading ? onClick : undefined}
    disabled={disabled}
    isLoading={loading}
    variant="text"
  >
    <Stack spacing={1}>
      <Typography fontWeight={600}>{title}</Typography>
      <Typography
        variant="caption1"
        component="p"
        sx={{
          wordBreak: "break-word",
          overflowWrap: "break-word",
          whiteSpace: "pre-wrap",
        }}
        color="text.secondary"
      >
        {description}
      </Typography>
    </Stack>
  </StyledButton>
);

export default PopoverButton;
